/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { ResponseResult } from "../../apis/response";
import { HELP_CALL } from "../../configs/info";
import MODAL_ARROW_ICON from "../../assets/images/modal_arrow.png";
import { csmsGetApiKey, csmsRepayUser } from "../../stores/actions/csms_action";
import { disabled_gray2 } from "../../styles/colors";
import { BtnOutLineBlue } from "../../styles/themes";
import { serverErrAlertMessage } from "../../validations/messages/messages";

export default function ModalRepay(props) {
  const dispatch = useDispatch();
  const [IsComplete, setIsComplete] = useState(false);
  const [Success, setSuccess] = useState(false);
  const [ResultMsg, setResultMsg] = useState("");
  const [Requesting, setRequesting] = useState(false);

  useEffect(() => {
    if (!props.show) {
      const timer = setTimeout(() => {
        setIsComplete(false);
        setRequesting(false);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [props.show]);

  const onClickRepayHandler = async () => {
    setRequesting(true);
    try {
      const tokenResponse = await dispatch(csmsGetApiKey());
      if (!tokenResponse.payload || !tokenResponse.payload.data) {
        setSuccess(false);
        setResultMsg(serverErrAlertMessage);
        setIsComplete(true);
        return;
      }
      const csmsToken = tokenResponse.payload.data.accessToken;

      const response = await dispatch(csmsRepayUser(props.userId, csmsToken));

      const isSuccess = response.payload.result === ResponseResult.OK && response.payload.data === true;
      setSuccess(isSuccess);
      setResultMsg(isSuccess
        ? "결제가 완료되었습니다."
        : `결제에 실패하였습니다.\n등록된 카드의 상태를 확인하시거나 다른 카드로 변경하여 다시 시도해주세요.\n문제가 지속될 경우 고객센터(${HELP_CALL})로 문의해주세요.`);
      setIsComplete(true);
    } catch (e) {
      setSuccess(false);
      setResultMsg(serverErrAlertMessage);
      setIsComplete(true);
    } finally {
      setRequesting(false);
    }
  }

  const onClickResultConfirmHandler = () => {
    if (Success) {
      window.location.reload();
    } else {
      props.onHide();
    }
  }

  return (
    <Modal
      show={props.show}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      autoFocus
      fullscreen="md-down"
      className={!IsComplete ? "mypage-modal" : "mypage-modal-alert"}
      css={css`.modal-content { height: auto !important; }`}
      onHide={props.onHide}
    >
      <div className="title">
        <img src={MODAL_ARROW_ICON} onClick={props.onHide} alt="close_icon" css={css`&:hover{cursor:pointer}`} />
        <h1>{!IsComplete ? "미결제 내역 재청구" : (Success ? "결제 성공" : "결제 실패")}</h1>
      </div>
      <Modal.Body className="container1 text-center">
        {
          !IsComplete
            ? <React.Fragment>
                <div css={css`font-weight: 400; font-size: 16px; line-height: 24px; color: ${disabled_gray2}; white-space: pre-line;`}>
                  등록된 결제 카드로 결제를 다시 시도하시겠습니까?
                </div>
                <div css={css`width: 100%; padding-top: 32px; display: flex; justify-content: space-around`}>
                  <button type="button" onClick={props.onHide} css={[BtnOutLineBlue, css`width: 45%; height: 48px;`]}>닫기</button>
                  <button type="button" disabled={Requesting} onClick={onClickRepayHandler} css={[BtnOutLineBlue, css`width: 45%; height: 48px;`]}>결제하기</button>
                </div>
              </React.Fragment>
            : <React.Fragment>
                <div css={css`font-weight: 400; font-size: 16px; line-height: 24px; white-space: pre-line; text-align: left;`}>
                  {ResultMsg}
                </div>
                <div css={css`width: 200px; padding: 45px 0; margin: 0 auto;`}>
                  <button onClick={onClickResultConfirmHandler} css={[BtnOutLineBlue, css` height: 48px;`]}>확인</button>
                </div>
              </React.Fragment>
        }
      </Modal.Body>
    </Modal>
  );
};
